import { Graphics } from "pixi.js";
import { LayerIndex } from "./LayerIndex";
import { ColorRgba } from "../utils/ColorRgba";

/**
 */
export class StageBackground extends Graphics {
  /**
   */
  public w: number;
  public h: number;
  public rgba: ColorRgba;

  /**
   *
   * @param app
   */
  constructor(color?: number) {
    super();
    this.rgba = new ColorRgba();
    this.rgba.on("set", this.drawBg, this);
    this.rgba.set(color || 0);
    this.layerIndex = LayerIndex.StageColor;
  }

  resize(width: number, height: number) {
    this.w = width;
    this.h = height;
    this.drawBg();
  }

  drawBg() {
    this.clear();
    this.beginFill(this.rgba.num, this.rgba.a);
    this.drawRect(0, 0, this.w + 16, this.h + 16);
    this.endFill();
  }
}
